/** Whether the file is the raw e-invoice XML itself, as opposed to e.g. a ZUGFeRD PDF. */
export function isXInvoiceXmlFile(file: File): boolean {
  return file.type === "application/xml" || file.type === "text/xml" || file.name.toLowerCase().endsWith(".xml");
}

/**
 * Extracts the specification identifier (BT-24) from a CII or UBL e-invoice XML document.
 * CII declares it under ExchangedDocumentContext/GuidelineSpecifiedDocumentContextParameter/ID,
 * UBL under the root CustomizationID.
 */
export function extractXInvoiceProfileUrn(xml: string, syntax: "cii" | "ubl"): string | undefined {
  let doc: Document;
  try {
    doc = new DOMParser().parseFromString(xml, "application/xml");
  } catch {
    return undefined;
  }

  if (doc.getElementsByTagName("parsererror").length) {
    return undefined;
  }

  if (syntax === "ubl") {
    return doc.getElementsByTagNameNS("*", "CustomizationID")[0]?.textContent?.trim() || undefined;
  }

  const context = doc.getElementsByTagNameNS("*", "GuidelineSpecifiedDocumentContextParameter")[0];
  return context?.getElementsByTagNameNS("*", "ID")[0]?.textContent?.trim() || undefined;
}
